module.exports = __webpack_public_path__ + "static/media/delete-icon.1cc05be2.svg";